export default {
    render(data) {
        const element = document.createElement('img');
        element.src = data.src;
        return element;
    },
    postRender(){},
}